import Cookies from 'js-cookie';

// Written by the marketing site's cookie banner. gclid capture and Mixpanel
// both read it, and the inline script in the marketing document head updates
// Google Consent Mode from the same cookie before GTM loads.
export const CONSENT_COOKIE = 'sc_cookie_consent';

export const CONSENT_EVENT = 'sc-consent';

export interface StoredConsentInterface {
  necessary: true;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
}

export const readStoredConsent = (): StoredConsentInterface | null => {
  if (typeof document === 'undefined') return null;

  const raw = Cookies.get(CONSENT_COOKIE);

  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Partial<StoredConsentInterface>;

    return {
      necessary: true,
      preferences: parsed.preferences === true,
      statistics: parsed.statistics === true,
      marketing: parsed.marketing === true,
    };
  } catch {
    return null;
  }
};
